import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'

import { DefaultDialog } from '@surglogs-app/ui.dialog'

import { AUTH_TRANSLATION_NAMESPACE } from '../translation'

interface SessionInactivityDialogProps {
  onConfirm: () => void
  onCancel: () => void
}

export const SessionInactivityDialog = memo(
  ({ onCancel, onConfirm }: SessionInactivityDialogProps) => {
    const { t } = useTranslation(AUTH_TRANSLATION_NAMESPACE)

    return (
      <DefaultDialog
        {...{
          title: t('sessionInactivity'),
          text: t('inactivityWarning'),
          onConfirm,
          confirmButtonLabel: t('continue'),
          onCancel,
          cancelButtonLabel: t('logout'),
        }}
      />
    )
  },
)
